<app-project-submenu></app-project-submenu>
<p-confirmdialog />
<ng-template #newBtn>
  <p-button
    i18n-label="@@add-secret"
    label="Secret hinzufügen"
    icon="ri-add-line"
    [styleClass]="secretService.projectSecrets.length === 0 ? 'p-button-primary' : 'p-button-secondary'"
    (click)="openAddModal()"
  ></p-button>
</ng-template>

@if (secretService.projectSecrets.length > 0) {
  <div
    class="d-flex justify-content-between align-items-center mb-2 mt-3"
    >
    <div class="d-flex gap-2 align-items-start">
      <ng-container [ngTemplateOutlet]="newBtn"></ng-container>
    </div>
    <p-iconfield>
      <p-inputicon class="ri ri-search-line" />
      <input
        pInputText
        type="text"
        #filterInput
        (input)="dt.filterGlobal(filterInput.value, 'contains')"
        i18n-placeholder="@@search-placeholder"
        placeholder="Suchen..."
        />
    </p-iconfield>
  </div>
}
<p-table
  #dt
  [globalFilterFields]="['name', 'description']"
  [value]="secretService.projectSecrets"
  class="p-datatable-gridlines-none"
  [rowHover]="secretService.projectSecrets.length > 0"
  >
  <ng-template #header>
    @if (secretService.projectSecrets.length > 0) {
      <tr>
        <th style="min-width: 82px;"></th>
        <th style="min-width: 250px; vertical-align: middle;">
          <span
            pSortableColumn="name"
            style="display: inline-flex; align-items: center;"
            >
            <ng-container i18n="@@name">Name</ng-container>
            <p-sorticon
              field="name"
              style="margin-left: 5px;"
              />
          </span>
        </th>
        <th style="width: 100%;">
          <span style="display: inline-flex; align-items: center;">
            <ng-container i18n="@@description">Beschreibung</ng-container>
          </span>
        </th>
        <th style="width: 141px; white-space: nowrap;">
          <span
            pSortableColumn="updated"
            style="display: inline-flex; align-items: center; justify-content: flex-end;"
            >
            <ng-container i18n="@@last-change">Aktualisiert</ng-container>
            <p-sorticon
              field="updated"
              style="margin-left: 5px;"
              />
          </span>
        </th>
        <th style="width: 72px;"></th>
      </tr>
    }
  </ng-template>

  <ng-template
    #body
    let-secret
    >
    <tr>
      <td style="width: 1px; vertical-align: top;">
        <i
          style="width: 80px; margin-right: 12px; margin-left: 13px;"
          class="ri-key-2-line ri-xl"
        ></i>
      </td>
      <td style="vertical-align: top;">
        <div class="d-flex flex-column">
          <span
            (click)="openEditModal(secret)"
            class="text-xl font-bold text-primary cursor-pointer hover:text-decoration-underline mb-1"
            >
            {{ secret.name }}
          </span>
        </div>
      </td>
      <td style="vertical-align: top;">
        <div class="d-flex flex-column">
          <span class="text-muted">
            @if (secret.description) {
              {{secret.description}}
            } @else {
              <ng-container i18n="@@no-description">Keine Beschreibung</ng-container>
            }
          </span>
        </div>
      </td>
      <td
        style="vertical-align: top;"
        [noWrap]="true"
        >
        <div>
          <span class="text-muted">{{ dayjs(secret.updated).fromNow() }}</span>
          <br>
            <span class="text-muted">{{ secret.updatedBy }}</span>
          </div>
        </td>
        <td style="vertical-align: top;">
          <p-popover
            [dismissable]="true"
            #popover
            appendTo="body"
            >
            <div class="flex flex-column">
              @for (item of contextMenu; track item) {
                <div
                  class="flex align-items-center gap-3 py-1 px-2 cursor-pointer popover-hover transition-colors transition-duration-150"
                  (click)="item.command(); popover.hide()"
                  >
                  <i
                    [class]="item.icon"
                    class="text-secondary me-3"
                  ></i>
                  <span class="text-color">{{ item.label }}</span>
                </div>
              }
            </div>
          </p-popover>
          <p-button
            #btn
            (click)="openMenu($event, popover, secret, btn) "
            rounded
            severity="secondary"
            icon="ri ri-more-2-fill"
            styleClass="button-icon"
            />
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td
          colspan="5"
          class="text-center p-5 text-muted"
          >
          @if (this.secretService.projectSecrets.length === 0) {
            <ng-container
              i18n="@@project-secrets-empty"
              >
          Noch keine Secrets vorhanden. Lege dein erstes Secret an.
        </ng-container>
          }
          @if (this.secretService.projectSecrets.length > 0) {
            <ng-container
              i18n="@@project-secrets-no-results"
              >
          <i class="ri ri-search-2-line"></i>
          Keine Ergebnisse gefunden.
        </ng-container>
          }
          <br><br>
          <div class="text-center d-flex flex-column gap-2">
            <ng-container [ngTemplateOutlet]="newBtn"></ng-container>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>